module.exports = "<h2>\n  {{title}}\n  <spinner inline=\"1\" ng-if=\"source.working\"></spinner>\n</h2>\n<div class=\"filter\"></div>\n<error worker=\"source\"></error>\n<div class=\"table\"></div>\n<pagination source=\"source\"></pagination>"


//////////////////
// WEBPACK FOOTER
// ./src/DataTable/ItemList.html
// module id = 450
// module chunks = 0